import styled from "styled-components";

const BackgroundTheme = styled.div`
  max-width: 100vw;
  background-color: #ffffff;
`;

const Holder = styled.div`
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 9999;
`;

export { BackgroundTheme, Holder };
